module.exports = "/assets/fonts/b0fef95e.svg";